export const HEALTH_SUMMARY_HTML_LOADED_SUCCESS = 'HEALTH_SUMMARY_HTML_LOADED_SUCCESS';
export const HEALTH_SUMMARY_HTML_LOADED_FAILED = 'HEALTH_SUMMARY_HTML_LOADED_FAILED';
export const MOST_RECENT_HEALTH_SUMMARY_LOADED_SUCCESS = 'MOST_RECENT_HEALTH_SUMMARY_LOADED_SUCCESS';
export const MOST_RECENT_HEALTH_SUMMARY_LOADED_FAILED = 'MOST_RECENT_HEALTH_SUMMARY_LOADED_FAILED';
export const HEALTH_SUMMARY_SET_DOWNLOAD_PATH = 'HEALTH_SUMMARY_SET_DOWNLOAD_PATH';
export const HEALTH_SUMMARY_CLEAR_LOADED_HTML = 'HEALTH_SUMMARY_CLEAR_LOADED_HTML';
export const HEALTH_SUMMARY_LIST_LOADED = 'HEALTH_SUMMARY_LIST_LOADED';
export const HEALTH_SUMMARY_LIST_LOAD_FAILED = 'HEALTH_SUMMARY_LIST_LOAD_FAILED';
export const HEALTH_SUMMARY_SELECTED = 'HEALTH_SUMMARY_SELECTED';
export const OPTIONS_SELECTED = 'OPTIONS_SELECTED';
export const RECENT_OFFICE_VISITS_LOADED_SUCCESS = 'RECENT_OFFICE_VISITS_LOADED_SUCCESS';
export const RECENT_OFFICE_VISITS_LOADED_FAILED = 'RECENT_OFFICE_VISITS_LOADED_FAILED';
export const HEALTH_SUMMARY_IDENTIFIER_UPDATE = 'HEALTH_SUMMARY_IDENTIFIER_UPDATE';
